module.exports = __webpack_public_path__ + "static/media/Appsidex_app_Recording.31302f42.mp4";